import React from "react";

const CarouselImage = (props) => {
    
    const { image, settings } = props;
    const { src, alt } = image || {};
    let position = "center center";
    const { options, format } = settings || {};
    if (format === "image.format.cropped-focus") {
        position = options?.position;
    }
    
    if (image) {
        return (
            <div
                className='home-banner-image'
                title={alt}
                style={{
                    width: "100%",
                    backgroundImage: `url(${src})`,
                    backgroundSize: "cover",
                    backgroundPosition: `${position}`,
                }}
            >
                {/*{image}*/}
                {/*{loaded &&*/}
                {/*    <img*/}
                {/*        src={url}*/}
                {/*        alt={alt}*/}
                {/*        className={aspect_class}*/}
                {/*    />*/}
                {/*}*/}
            </div>
        );
    } else {
        return (
            <div className='carousel-loading'>
                <div className='loader'>
                    {/*Loading image...*/}
                </div>
            </div>
        );
    }
};

export { CarouselImage };
